import React, { useEffect, useState } from "react";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useDispatch, useSelector } from "react-redux";
import { de } from "@faker-js/faker";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import winEmblem from './../../assets/images/WinRpundedLogo-pink.png';
import moreArrow from './../../assets/images/rightArrow.png';

const New_Authorization = ({ memberId = "test_LSKm", contract = "ZYX Sales Corp - Premier" }) => {
 const userInfo = useSelector((state) => state.userData);
 const { t, i18n } = useTranslation();
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const navigate = useNavigate();
  const [rxDetail, setRxDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRxDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = {
        //   MemberID: "test_LSKm",
        //   Contract: "ZYX Sales Corp - Premier",
        MemberID: userInfo.userData.MemberID,
          Contract: userInfo.userData.ContractIdentified,
          EmailID: userInfo.userData.EmailID,
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        };
        const token = localStorage.getItem("AccessToken");
        const response = await axios.post(
          Endpoints.GetRXDetailsList,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // debugger
        console.log("RX Details Response:", response.data);
        if (response.data && response.data.RXDetails) {
          setRxDetail(response.data);
        
        } else {
          setRxDetail(null);
        }
      } catch (err) {
        setError("Failed to fetch RX details.");
      } finally {
        setLoading(false);
      }
    };
    fetchRxDetails();
  }, [memberId, contract]);

    const handleItemClick = (auth) => {
      navigate('/request-authorization', {
        state: {
          selectedRxItem: auth,
          DrugNames,
          PharmNames
        }
      });
  };

  const handleBackClick = () => {
      navigate(-1); // Go back to the previous page
    };
  if (loading) {
    return <div>Loading RX details...</div>;
  }
  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }
  if (!rxDetail) {
    return (
      <div className="no-data-available flex-column">
        <div className="d-flex">No RX details available.</div>
      </div>
    );
  }
  // Only destructure after null check
  const { RXDetails, DrugNames, PharmNames } = rxDetail;

  return (
    <>
      {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">Prescription Authorization Details</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
            </span>
          </button>       
          <h2 className="page-heading">Prescription Authorization Details</h2>
        </div>
      }
      {Array.isArray(RXDetails) && RXDetails.length > 0 ? (
        <div style={{ marginBottom: 24 }}>
          <div className="col-md-12 mt-2 d-md-flex flex-wrap rx-auth-wrapper">
            {RXDetails.map((item, idx) => (
              <div
                key={item.AuthNo || idx}
                className="rx-auth-block-wrapper"
                onClick={() => handleItemClick(item)}
              >
                {/* Logo */}
                <div className="rx-auth-block-win-emblem">
                  <img src={winEmblem} alt="WIN Logo" />
                </div>

                {/* Content */}
                <div className="rx-auth-block-content-wrapper">
                  <h4 className="page-heading-secondary-black">
                    <span>Treatment Name: {item.CPTDesc || "Not Available"}</span>
                  </h4>
                  <p>
                    <span> Date Range :
                      ({item.RequestFromDate || "Start Date Not Available"} -{" "}
                      {item.RequestToDate || "End Date Not Available"})
                    </span>
                  </p>
                  {item.ProviderName && (
                    <p>
                      Provider Name: {item.ProviderName}
                    </p>
                  )}                  
                </div>
                {/* Arrow */}
                <div className="rx-auth-block-more-arrow">
                  <img src={moreArrow} alt="More" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div>No RX authorizations found.</div>
      )}
    </>
  );
};

export default New_Authorization;
